// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detalle-requerimiento {
  max-width: 1500px;
  margin: 0 auto;
  animation: fadeInUp 0.5s ease;
}

.detalle-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px 24px;
  background: var(--bg-card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  transition: var(--transition);
}

.detalle-header:hover {
  box-shadow: var(--shadow-md);
}

.btn-back {
  padding: 8px 16px;
  background: var(--white);
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
  color: var(--gray-700);
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-back:hover {
  background: var(--gray-50);
  border-color: var(--gray-400);
  transform: translateX(-2px);
}

.detalle-header h2 {
  margin: 0;
  color: var(--gray-900);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.detalle-grid {
  display: grid;
  gap: 20px;
}

.detalle-seccion {
  background: var(--bg-card);
  padding: 24px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  transition: var(--transition);
  animation: fadeInUp 0.4s ease;
  animation-fill-mode: both;
}

.detalle-seccion:nth-child(1) { animation-delay: 0.05s; }
.detalle-seccion:nth-child(2) { animation-delay: 0.1s; }
.detalle-seccion:nth-child(3) { animation-delay: 0.15s; }
.detalle-seccion:nth-child(4) { animation-delay: 0.2s; }

.detalle-seccion:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.detalle-seccion h3 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--border);
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  background: var(--gray-50);
  border-radius: var(--radius);
  transition: var(--transition);
}

.info-item:hover {
  background: var(--primary-ultralight);
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-item label {
  font-size: 11px;
  color: var(--text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.info-item span,
.info-item p {
  font-size: 15px;
  color: var(--gray-800);
  font-weight: 500;
}

.archivos {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.archivo-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  background: var(--primary-ultralight);
  color: var(--primary);
  text-decoration: none;
  border-radius: var(--radius);
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
  border: 1px solid var(--primary-light);
}

.archivo-link:hover {
  background: var(--primary);
  color: var(--white);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.acciones-container {
  background: var(--bg-card);
  padding: 24px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  margin-top: 20px;
  border: 1px solid var(--border);
}

.acciones-container h3 {
  margin-bottom: 16px;
  color: var(--gray-800);
  font-size: 16px;
  font-weight: 600;
}

.acciones-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-accion {
  padding: 12px 24px;
  background: linear-gradient(135deg, var(--success), var(--success-dark));
  color: var(--white);
  border: none;
  border-radius: var(--radius);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.btn-accion:hover {
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.4);
  transform: translateY(-2px);
}

.error {
  text-align: center;
  padding: 60px;
  color: var(--danger);
  font-size: 18px;
  animation: fadeIn 0.3s ease;
}

/* Formulario de edición */
.form-requerimiento {
  background: var(--bg-card);
  padding: 28px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
}

.form-section {
  margin-bottom: 28px;
  padding-bottom: 28px;
  border-bottom: 1px solid var(--border);
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.form-section h3 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 700;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--border);
}

@media (max-width: 768px) {
  .detalle-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
  }

  .detalle-header h2 {
    font-size: 18px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .acciones-grid {
    flex-direction: column;
  }

  .btn-accion {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .criticidad-buttons {
    flex-direction: column;
    gap: 8px;
  }

  .acciones-buttons {
    flex-direction: column;
    gap: 8px;
  }

  .btn-success, .btn-danger {
    width: 100%;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}

/* Panel de Acciones v2.1 */
.panel-acciones {
  background: var(--bg-card);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: 24px;
  margin-top: 24px;
  box-shadow: var(--shadow-sm);
  animation: fadeInUp 0.4s ease;
}

.panel-acciones h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  color: var(--gray-900);
  border-bottom: 1.5px solid var(--border);
  padding-bottom: 8px;
}

.section-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-700);
  margin-bottom: 8px;
  text-transform: none !important;
}

.criticidad-selection {
  margin-bottom: 20px;
}

.criticidad-buttons {
  display: flex;
  gap: 12px;
}

.btn-crit {
  flex: 1 1;
  padding: 10px;
  border-radius: var(--radius);
  border: 1.5px solid var(--border);
  background: var(--white);
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: var(--transition);
}

.btn-crit.alta:hover,
.btn-crit.alta.selected {
  border-color: #f56565;
  background-color: #fff5f5;
  color: #c53030;
}

.btn-crit.media:hover,
.btn-crit.media.selected {
  border-color: #ecc94b;
  background-color: #fefcbf;
  color: #b7791f;
}

.btn-crit.baja:hover,
.btn-crit.baja.selected {
  border-color: #48bb78;
  background-color: #f0fff4;
  color: #276749;
}

.comentario-group {
  margin-bottom: 20px;
}

.input-comentario {
  width: 100%;
  padding: 12px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  transition: var(--transition);
}

.input-comentario:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
}

.acciones-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-success {
  padding: 12px 24px;
  background: linear-gradient(135deg, #48bb78, #276749);
  color: var(--white);
  border: none;
  border-radius: var(--radius);
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(72, 187, 120, 0.3);
  transition: var(--transition);
}

.btn-success:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(72, 187, 120, 0.4);
}

.btn-danger {
  padding: 12px 24px;
  background: linear-gradient(135deg, #e53e3e, #9b2c2c);
  color: var(--white);
  border: none;
  border-radius: var(--radius);
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.3);
  transition: var(--transition);
}

.btn-danger:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(229, 62, 62, 0.4);
}

.proveedor-fields {
  margin-bottom: 24px;
  background: var(--gray-50);
  padding: 16px;
  border-radius: var(--radius);
  border: 1px dashed var(--border);
}

.no-rate-warning {
  grid-column: 1 / -1;
  background-color: #fffaf0;
  border: 1px solid #feebc8;
  color: #dd6b20;
  padding: 12px 16px;
  border-radius: var(--radius);
  font-size: 14px;
  font-weight: 500;
}

.rechazo-seccion {
  border-left: 4px solid #e53e3e !important;
  background-color: #fff5f5 !important;
}

.rechazo-texto {
  color: #c53030 !important;
  font-weight: 500;
  line-height: 1.5;
}

/* Panel cuando el analista ya registró el proveedor */
.proveedor-ya-registrado {
  margin-bottom: 20px;
  background: linear-gradient(135deg, #f0fff4, #e6fffa);
  border: 1.5px solid #68d391;
  border-radius: var(--radius);
  padding: 16px;
}

[data-theme="dark"] .proveedor-ya-registrado {
  background: rgba(72, 187, 120, 0.1);
  border-color: #276749;
}

.proveedor-badge {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 4px;
}

.badge-icon {
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
}

.proveedor-badge strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #276749;
  margin-bottom: 2px;
}

[data-theme="dark"] .proveedor-badge strong {
  color: #68d391;
}

.proveedor-badge p {
  margin: 0;
  font-size: 13px;
  color: var(--text-muted);
}


[data-theme="dark"] .info-item {
  background: var(--bg-subtle);
}

[data-theme="dark"] .info-item span,
[data-theme="dark"] .info-item p {
  color: #ffffff;
}

[data-theme="dark"] .detalle-header h2,
[data-theme="dark"] .detalle-seccion h3,
[data-theme="dark"] .acciones-container h3,
[data-theme="dark"] .panel-acciones h3 {
  color: #ffffff;
}

[data-theme="dark"] .btn-back {
  background: var(--bg-subtle);
  color: #ffffff;
  border-color: var(--border);
}

[data-theme="dark"] .btn-back:hover {
  background: rgba(255, 255, 255, 0.05);
}

[data-theme="dark"] .proveedor-fields {
  background: var(--bg-subtle);
  border-color: var(--border);
}

[data-theme="dark"] .no-rate-warning {
  background-color: rgba(245, 158, 11, 0.15);
  border-color: rgba(245, 158, 11, 0.3);
  color: #fbbf24;
}

[data-theme="dark"] .rechazo-seccion {
  background-color: rgba(229, 62, 62, 0.15) !important;
  border-color: #ef4444 !important;
}

[data-theme="dark"] .rechazo-texto {
  color: #f87171 !important;
}

[data-theme="dark"] .btn-crit {
  background-color: var(--bg-subtle);
  color: var(--text);
  border-color: var(--border);
}

[data-theme="dark"] .btn-crit.alta:hover,
[data-theme="dark"] .btn-crit.alta.selected {
  border-color: #ef4444;
  background-color: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

[data-theme="dark"] .btn-crit.media:hover,
[data-theme="dark"] .btn-crit.media.selected {
  border-color: #fbbf24;
  background-color: rgba(251, 191, 36, 0.15);
  color: #fbbf24;
}

[data-theme="dark"] .btn-crit.baja:hover,
[data-theme="dark"] .btn-crit.baja.selected {
  border-color: #34d399;
  background-color: rgba(52, 211, 153, 0.15);
  color: #34d399;
}

[data-theme="dark"] .input-comentario {
  background-color: var(--bg-subtle);
  color: var(--text);
  border-color: var(--border);
}

[data-theme="dark"] .input-comentario:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
}

[data-theme="dark"] .section-label {
  color: var(--text-secondary);
}

[data-theme="dark"] .archivo-link {
  background-color: var(--bg-subtle);
  color: #60a5fa;
  border-color: #2563eb;
}

[data-theme="dark"] .archivo-link:hover {
  background-color: #2563eb;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

/* Observaciones del Proveedor / Requerimiento */
.observacion-proveedor-alert {
  background-color: var(--primary-ultralight, #eff6ff);
  border: 1px solid var(--primary-300, #bfdbfe);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.observacion-proveedor-alert h4 {
  color: var(--primary, #1e3a8a);
  margin-top: 0;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
}

.observacion-proveedor-alert p {
  color: var(--text, #1e40af);
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
}

.observacion-proveedor-alert .hint-text {
  color: var(--text-muted, #4b5563);
  margin-top: 8px;
  font-size: 12px;
  font-style: italic;
}

[data-theme="dark"] .observacion-proveedor-alert {
  background-color: rgba(96, 165, 250, 0.1);
  border-color: rgba(96, 165, 250, 0.2);
}

[data-theme="dark"] .observacion-proveedor-alert h4 {
  color: #60a5fa;
}

[data-theme="dark"] .observacion-proveedor-alert p {
  color: var(--text);
}

[data-theme="dark"] .observacion-proveedor-alert .hint-text {
  color: var(--text-muted);
}

.observacion-info-box {
  margin-top: 8px;
  background-color: var(--primary-ultralight, #eff6ff);
  padding: 12px;
  border-radius: 6px;
  border: 1px solid var(--primary-200, #bfdbfe);
}

.observacion-info-box label {
  color: var(--primary, #1e3a8a) !important;
  font-weight: bold;
}

.observacion-info-box span {
  color: var(--text, #1e40af) !important;
  display: block;
  margin-top: 4px;
  font-style: italic;
}

[data-theme="dark"] .observacion-info-box {
  background-color: rgba(96, 165, 250, 0.1);
  border-color: rgba(96, 165, 250, 0.2);
}

[data-theme="dark"] .observacion-info-box label {
  color: #60a5fa !important;
}

[data-theme="dark"] .observacion-info-box span {
  color: var(--text) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DetalleRequerimiento.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iCAAiC;EACjC,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,gCAAgC,sBAAsB,EAAE;AACxD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,sBAAsB,EAAE;AACxD,gCAAgC,qBAAqB,EAAE;;AAEvD;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wEAAwE;EACxE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,qDAAqD;EACrD,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6CAA6C;AAC/C;;AAEA,gDAAgD;AAChD;EACE,oDAAoD;EACpD,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,oDAAoD;EACpD,aAAa;EACb,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".detalle-requerimiento {\n  max-width: 1500px;\n  margin: 0 auto;\n  animation: fadeInUp 0.5s ease;\n}\n\n.detalle-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 20px 24px;\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  transition: var(--transition);\n}\n\n.detalle-header:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.btn-back {\n  padding: 8px 16px;\n  background: var(--white);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n  color: var(--gray-700);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-back:hover {\n  background: var(--gray-50);\n  border-color: var(--gray-400);\n  transform: translateX(-2px);\n}\n\n.detalle-header h2 {\n  margin: 0;\n  color: var(--gray-900);\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n}\n\n.detalle-grid {\n  display: grid;\n  gap: 20px;\n}\n\n.detalle-seccion {\n  background: var(--bg-card);\n  padding: 24px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  transition: var(--transition);\n  animation: fadeInUp 0.4s ease;\n  animation-fill-mode: both;\n}\n\n.detalle-seccion:nth-child(1) { animation-delay: 0.05s; }\n.detalle-seccion:nth-child(2) { animation-delay: 0.1s; }\n.detalle-seccion:nth-child(3) { animation-delay: 0.15s; }\n.detalle-seccion:nth-child(4) { animation-delay: 0.2s; }\n\n.detalle-seccion:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.detalle-seccion h3 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 18px;\n  font-weight: 700;\n  padding-bottom: 12px;\n  border-bottom: 2px solid var(--border);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 16px;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n  transition: var(--transition);\n}\n\n.info-item:hover {\n  background: var(--primary-ultralight);\n}\n\n.info-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.info-item label {\n  font-size: 11px;\n  color: var(--text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n\n.info-item span,\n.info-item p {\n  font-size: 15px;\n  color: var(--gray-800);\n  font-weight: 500;\n}\n\n.archivos {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.archivo-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 18px;\n  background: var(--primary-ultralight);\n  color: var(--primary);\n  text-decoration: none;\n  border-radius: var(--radius);\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n  border: 1px solid var(--primary-light);\n}\n\n.archivo-link:hover {\n  background: var(--primary);\n  color: var(--white);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.acciones-container {\n  background: var(--bg-card);\n  padding: 24px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  margin-top: 20px;\n  border: 1px solid var(--border);\n}\n\n.acciones-container h3 {\n  margin-bottom: 16px;\n  color: var(--gray-800);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.acciones-grid {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.btn-accion {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, var(--success), var(--success-dark));\n  color: var(--white);\n  border: none;\n  border-radius: var(--radius);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);\n}\n\n.btn-accion:hover {\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.4);\n  transform: translateY(-2px);\n}\n\n.error {\n  text-align: center;\n  padding: 60px;\n  color: var(--danger);\n  font-size: 18px;\n  animation: fadeIn 0.3s ease;\n}\n\n/* Formulario de edición */\n.form-requerimiento {\n  background: var(--bg-card);\n  padding: 28px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n}\n\n.form-section {\n  margin-bottom: 28px;\n  padding-bottom: 28px;\n  border-bottom: 1px solid var(--border);\n}\n\n.form-section:last-of-type {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.form-section h3 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border);\n}\n\n@media (max-width: 768px) {\n  .detalle-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 16px;\n  }\n\n  .detalle-header h2 {\n    font-size: 18px;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .acciones-grid {\n    flex-direction: column;\n  }\n\n  .btn-accion {\n    width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .criticidad-buttons {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .acciones-buttons {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .btn-success, .btn-danger {\n    width: 100%;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Panel de Acciones v2.1 */\n.panel-acciones {\n  background: var(--bg-card);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 24px;\n  margin-top: 24px;\n  box-shadow: var(--shadow-sm);\n  animation: fadeInUp 0.4s ease;\n}\n\n.panel-acciones h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 18px;\n  color: var(--gray-900);\n  border-bottom: 1.5px solid var(--border);\n  padding-bottom: 8px;\n}\n\n.section-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gray-700);\n  margin-bottom: 8px;\n  text-transform: none !important;\n}\n\n.criticidad-selection {\n  margin-bottom: 20px;\n}\n\n.criticidad-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-crit {\n  flex: 1;\n  padding: 10px;\n  border-radius: var(--radius);\n  border: 1.5px solid var(--border);\n  background: var(--white);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: var(--transition);\n}\n\n.btn-crit.alta:hover,\n.btn-crit.alta.selected {\n  border-color: #f56565;\n  background-color: #fff5f5;\n  color: #c53030;\n}\n\n.btn-crit.media:hover,\n.btn-crit.media.selected {\n  border-color: #ecc94b;\n  background-color: #fefcbf;\n  color: #b7791f;\n}\n\n.btn-crit.baja:hover,\n.btn-crit.baja.selected {\n  border-color: #48bb78;\n  background-color: #f0fff4;\n  color: #276749;\n}\n\n.comentario-group {\n  margin-bottom: 20px;\n}\n\n.input-comentario {\n  width: 100%;\n  padding: 12px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius);\n  font-family: inherit;\n  font-size: 14px;\n  resize: vertical;\n  transition: var(--transition);\n}\n\n.input-comentario:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n}\n\n.acciones-buttons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.btn-success {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #48bb78, #276749);\n  color: var(--white);\n  border: none;\n  border-radius: var(--radius);\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(72, 187, 120, 0.3);\n  transition: var(--transition);\n}\n\n.btn-success:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(72, 187, 120, 0.4);\n}\n\n.btn-danger {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #e53e3e, #9b2c2c);\n  color: var(--white);\n  border: none;\n  border-radius: var(--radius);\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.3);\n  transition: var(--transition);\n}\n\n.btn-danger:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(229, 62, 62, 0.4);\n}\n\n.proveedor-fields {\n  margin-bottom: 24px;\n  background: var(--gray-50);\n  padding: 16px;\n  border-radius: var(--radius);\n  border: 1px dashed var(--border);\n}\n\n.no-rate-warning {\n  grid-column: 1 / -1;\n  background-color: #fffaf0;\n  border: 1px solid #feebc8;\n  color: #dd6b20;\n  padding: 12px 16px;\n  border-radius: var(--radius);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.rechazo-seccion {\n  border-left: 4px solid #e53e3e !important;\n  background-color: #fff5f5 !important;\n}\n\n.rechazo-texto {\n  color: #c53030 !important;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n/* Panel cuando el analista ya registró el proveedor */\n.proveedor-ya-registrado {\n  margin-bottom: 20px;\n  background: linear-gradient(135deg, #f0fff4, #e6fffa);\n  border: 1.5px solid #68d391;\n  border-radius: var(--radius);\n  padding: 16px;\n}\n\n[data-theme=\"dark\"] .proveedor-ya-registrado {\n  background: rgba(72, 187, 120, 0.1);\n  border-color: #276749;\n}\n\n.proveedor-badge {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.badge-icon {\n  font-size: 24px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.proveedor-badge strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #276749;\n  margin-bottom: 2px;\n}\n\n[data-theme=\"dark\"] .proveedor-badge strong {\n  color: #68d391;\n}\n\n.proveedor-badge p {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\r\n\n[data-theme=\"dark\"] .info-item {\n  background: var(--bg-subtle);\n}\n\n[data-theme=\"dark\"] .info-item span,\n[data-theme=\"dark\"] .info-item p {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .detalle-header h2,\n[data-theme=\"dark\"] .detalle-seccion h3,\n[data-theme=\"dark\"] .acciones-container h3,\n[data-theme=\"dark\"] .panel-acciones h3 {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .btn-back {\n  background: var(--bg-subtle);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .btn-back:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n[data-theme=\"dark\"] .proveedor-fields {\n  background: var(--bg-subtle);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .no-rate-warning {\n  background-color: rgba(245, 158, 11, 0.15);\n  border-color: rgba(245, 158, 11, 0.3);\n  color: #fbbf24;\n}\n\n[data-theme=\"dark\"] .rechazo-seccion {\n  background-color: rgba(229, 62, 62, 0.15) !important;\n  border-color: #ef4444 !important;\n}\n\n[data-theme=\"dark\"] .rechazo-texto {\n  color: #f87171 !important;\n}\n\n[data-theme=\"dark\"] .btn-crit {\n  background-color: var(--bg-subtle);\n  color: var(--text);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .btn-crit.alta:hover,\n[data-theme=\"dark\"] .btn-crit.alta.selected {\n  border-color: #ef4444;\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n[data-theme=\"dark\"] .btn-crit.media:hover,\n[data-theme=\"dark\"] .btn-crit.media.selected {\n  border-color: #fbbf24;\n  background-color: rgba(251, 191, 36, 0.15);\n  color: #fbbf24;\n}\n\n[data-theme=\"dark\"] .btn-crit.baja:hover,\n[data-theme=\"dark\"] .btn-crit.baja.selected {\n  border-color: #34d399;\n  background-color: rgba(52, 211, 153, 0.15);\n  color: #34d399;\n}\n\n[data-theme=\"dark\"] .input-comentario {\n  background-color: var(--bg-subtle);\n  color: var(--text);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .input-comentario:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n}\n\n[data-theme=\"dark\"] .section-label {\n  color: var(--text-secondary);\n}\n\n[data-theme=\"dark\"] .archivo-link {\n  background-color: var(--bg-subtle);\n  color: #60a5fa;\n  border-color: #2563eb;\n}\n\n[data-theme=\"dark\"] .archivo-link:hover {\n  background-color: #2563eb;\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n/* Observaciones del Proveedor / Requerimiento */\n.observacion-proveedor-alert {\n  background-color: var(--primary-ultralight, #eff6ff);\n  border: 1px solid var(--primary-300, #bfdbfe);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.observacion-proveedor-alert h4 {\n  color: var(--primary, #1e3a8a);\n  margin-top: 0;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n}\n\n.observacion-proveedor-alert p {\n  color: var(--text, #1e40af);\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.observacion-proveedor-alert .hint-text {\n  color: var(--text-muted, #4b5563);\n  margin-top: 8px;\n  font-size: 12px;\n  font-style: italic;\n}\n\n[data-theme=\"dark\"] .observacion-proveedor-alert {\n  background-color: rgba(96, 165, 250, 0.1);\n  border-color: rgba(96, 165, 250, 0.2);\n}\n\n[data-theme=\"dark\"] .observacion-proveedor-alert h4 {\n  color: #60a5fa;\n}\n\n[data-theme=\"dark\"] .observacion-proveedor-alert p {\n  color: var(--text);\n}\n\n[data-theme=\"dark\"] .observacion-proveedor-alert .hint-text {\n  color: var(--text-muted);\n}\n\n.observacion-info-box {\n  margin-top: 8px;\n  background-color: var(--primary-ultralight, #eff6ff);\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid var(--primary-200, #bfdbfe);\n}\n\n.observacion-info-box label {\n  color: var(--primary, #1e3a8a) !important;\n  font-weight: bold;\n}\n\n.observacion-info-box span {\n  color: var(--text, #1e40af) !important;\n  display: block;\n  margin-top: 4px;\n  font-style: italic;\n}\n\n[data-theme=\"dark\"] .observacion-info-box {\n  background-color: rgba(96, 165, 250, 0.1);\n  border-color: rgba(96, 165, 250, 0.2);\n}\n\n[data-theme=\"dark\"] .observacion-info-box label {\n  color: #60a5fa !important;\n}\n\n[data-theme=\"dark\"] .observacion-info-box span {\n  color: var(--text) !important;\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
